var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "scroll-pane",
    [
      _c("action-header", { attrs: { slot: "header" }, slot: "header" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: _vm.$t("VuexHistory.filter.tooltip"),
                expression: "$t('VuexHistory.filter.tooltip')"
              }
            ],
            staticClass: "search"
          },
          [
            _c("VueIcon", { attrs: { icon: "search" } }),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.filter,
                  expression: "filter",
                  modifiers: { trim: true }
                }
              ],
              ref: "filterMutations",
              class: { invalid: _vm.filterRegexInvalid },
              attrs: { placeholder: "Filter mutations" },
              domProps: { value: _vm.filter },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.filter = $event.target.value.trim()
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ],
          1
        ),
        _c(
          "a",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: _vm.$t("VuexHistory.commitAll.tooltip"),
                expression: "$t('VuexHistory.commitAll.tooltip')"
              }
            ],
            staticClass: "button commit-all",
            class: { disabled: !_vm.history.length },
            on: { click: _vm.commitAll }
          },
          [
            _c("VueIcon", { attrs: { icon: "get_app" } }),
            _c("span", [_vm._v("Commit All")])
          ],
          1
        ),
        _c(
          "a",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: _vm.$t("VuexHistory.revertAll.tooltip"),
                expression: "$t('VuexHistory.revertAll.tooltip')"
              }
            ],
            staticClass: "button reset",
            class: { disabled: !_vm.history.length },
            on: { click: _vm.revertAll }
          },
          [
            _c("VueIcon", {
              staticClass: "small",
              attrs: { icon: "do_not_disturb" }
            }),
            _c("span", [_vm._v("Revert All")])
          ],
          1
        ),
        _c(
          "a",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: _vm.$t(
                  "VuexHistory." +
                    (_vm.$shared.recordVuex
                      ? "stopRecording"
                      : "startRecording") +
                    ".tooltip"
                ),
                expression:
                  "$t(`VuexHistory.${$shared.recordVuex ? 'stopRecording' : 'startRecording'}.tooltip`)"
              }
            ],
            staticClass: "button toggle-recording",
            on: { click: _vm.toggleRecording }
          },
          [
            _c("VueIcon", {
              staticClass: "small",
              class: { enabled: _vm.$shared.recordVuex },
              attrs: { icon: "lens" }
            }),
            _c("span", [
              _vm._v(_vm._s(_vm.$shared.recordVuex ? "Recording" : "Paused"))
            ])
          ],
          1
        )
      ]),
      _c("RecycleScroller", {
        staticClass: "history",
        class: {
          "high-density": _vm.highDensity
        },
        attrs: {
          slot: "scroll",
          items: _vm.filter
            ? _vm.filteredHistory
            : [{ id: -1 }].concat(_vm.filteredHistory),
          "item-size": _vm.highDensity ? 22 : 34
        },
        slot: "scroll",
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var entry = ref.item
              var index = ref.index
              var active = ref.active
              return [
                !entry.mutation
                  ? _c(
                      "div",
                      {
                        staticClass: "entry list-item special",
                        class: {
                          active: _vm.activeIndex === -1,
                          inspected: _vm.inspectedIndex === -1
                        },
                        attrs: { "data-active": active, "data-index": index },
                        on: {
                          click: function($event) {
                            return _vm.inspect(null)
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "entry-info" }, [
                          _c("span", { staticClass: "mutation-type" }, [
                            _vm._v("Base State")
                          ]),
                          _c("span", { staticClass: "entry-actions" }, [
                            _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: "Time Travel to This State",
                                    expression: "'Time Travel to This State'"
                                  }
                                ],
                                staticClass: "action action-time-travel",
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.timeTravelTo(null)
                                  }
                                }
                              },
                              [
                                _c("VueIcon", {
                                  staticClass: "medium",
                                  attrs: { icon: "restore" }
                                }),
                                _c("span", [_vm._v("Time Travel")])
                              ],
                              1
                            )
                          ])
                        ]),
                        _vm.activeIndex === -1
                          ? _c("span", { staticClass: "label active" }, [
                              _vm._v("active")
                            ])
                          : _vm._e(),
                        _vm.inspectedIndex === -1
                          ? _c("span", { staticClass: "label inspected" }, [
                              _vm._v("inspected")
                            ])
                          : _vm._e(),
                        _c("span", { staticClass: "time" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm._f("formatTime")(
                                  _vm.lastCommit,
                                  _vm.$shared.timeFormat
                                )
                              ) +
                              "\n        "
                          )
                        ])
                      ]
                    )
                  : _c(
                      "div",
                      {
                        staticClass: "entry list-item",
                        class: {
                          inspected: _vm.isInspected(index, entry),
                          active: _vm.isActive(index, entry),
                          special: _vm.isSpecial(entry)
                        },
                        attrs: { "data-active": active, "data-index": index },
                        on: {
                          click: function($event) {
                            return _vm.inspect(entry)
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "entry-info" }, [
                          _c("span", { staticClass: "mutation-type" }, [
                            _vm._v(_vm._s(entry.mutation.type))
                          ]),
                          _c("span", { staticClass: "entry-actions" }, [
                            _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: "Commit This Mutation",
                                    expression: "'Commit This Mutation'"
                                  }
                                ],
                                staticClass: "action action-commit",
                                on: {
                                  click: function($event) {
                                    _vm.commit(entry)
                                    $event.stopImmediatePropagation()
                                  }
                                }
                              },
                              [
                                _c("VueIcon", {
                                  staticClass: "medium",
                                  attrs: { icon: "get_app" }
                                }),
                                _c("span", [_vm._v("Commit")])
                              ],
                              1
                            ),
                            _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: "Revert This Mutation",
                                    expression: "'Revert This Mutation'"
                                  }
                                ],
                                staticClass: "action action-revert",
                                on: {
                                  click: function($event) {
                                    _vm.revert(entry)
                                    $event.stopImmediatePropagation()
                                  }
                                }
                              },
                              [
                                _c("VueIcon", {
                                  staticClass: "small",
                                  attrs: { icon: "do_not_disturb" }
                                }),
                                _c("span", [_vm._v("Revert")])
                              ],
                              1
                            ),
                            !_vm.isActive(index, entry)
                              ? _c(
                                  "a",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: "Time Travel to This State",
                                        expression:
                                          "'Time Travel to This State'"
                                      }
                                    ],
                                    staticClass: "action action-time-travel",
                                    on: {
                                      click: function($event) {
                                        return _vm.timeTravelTo(entry)
                                      }
                                    }
                                  },
                                  [
                                    _c("VueIcon", {
                                      staticClass: "medium",
                                      attrs: { icon: "restore" }
                                    }),
                                    _c("span", [_vm._v("Time Travel")])
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        ]),
                        _vm.isActive(index, entry)
                          ? _c("span", { staticClass: "label active" }, [
                              _vm._v("active")
                            ])
                          : _vm._e(),
                        _vm.isInspected(index, entry)
                          ? _c("span", { staticClass: "label inspected" }, [
                              _vm._v("inspected")
                            ])
                          : _vm._e(),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: entry.timestamp,
                                expression: "entry.timestamp"
                              }
                            ],
                            staticClass: "time"
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm._f("formatTime")(
                                    entry.timestamp,
                                    _vm.$shared.timeFormat
                                  )
                                ) +
                                "\n        "
                            )
                          ]
                        )
                      ]
                    )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }